var map = {
	"./ion-action-sheet.entry.js": [
		129,
		73
	],
	"./ion-alert.entry.js": [
		130,
		74
	],
	"./ion-app_8.entry.js": [
		131,
		75
	],
	"./ion-avatar_3.entry.js": [
		132,
		87
	],
	"./ion-back-button.entry.js": [
		133,
		88
	],
	"./ion-backdrop.entry.js": [
		134,
		117
	],
	"./ion-button_2.entry.js": [
		135,
		89
	],
	"./ion-card_5.entry.js": [
		136,
		90
	],
	"./ion-checkbox.entry.js": [
		137,
		91
	],
	"./ion-chip.entry.js": [
		138,
		92
	],
	"./ion-col_3.entry.js": [
		139,
		118
	],
	"./ion-datetime_3.entry.js": [
		140,
		78
	],
	"./ion-fab_3.entry.js": [
		141,
		93
	],
	"./ion-img.entry.js": [
		142,
		119
	],
	"./ion-infinite-scroll_2.entry.js": [
		143,
		120
	],
	"./ion-input.entry.js": [
		144,
		94
	],
	"./ion-item-option_3.entry.js": [
		145,
		95
	],
	"./ion-item_8.entry.js": [
		146,
		96
	],
	"./ion-loading.entry.js": [
		147,
		97
	],
	"./ion-menu_3.entry.js": [
		148,
		98
	],
	"./ion-modal.entry.js": [
		149,
		76
	],
	"./ion-nav_2.entry.js": [
		150,
		84
	],
	"./ion-popover.entry.js": [
		151,
		77
	],
	"./ion-progress-bar.entry.js": [
		152,
		99
	],
	"./ion-radio_2.entry.js": [
		153,
		100
	],
	"./ion-range.entry.js": [
		154,
		101
	],
	"./ion-refresher_2.entry.js": [
		155,
		79
	],
	"./ion-reorder_2.entry.js": [
		156,
		86
	],
	"./ion-ripple-effect.entry.js": [
		157,
		121
	],
	"./ion-route_4.entry.js": [
		158,
		102
	],
	"./ion-searchbar.entry.js": [
		159,
		103
	],
	"./ion-segment_2.entry.js": [
		160,
		104
	],
	"./ion-select_3.entry.js": [
		161,
		105
	],
	"./ion-slide_2.entry.js": [
		162,
		122
	],
	"./ion-spinner.entry.js": [
		163,
		81
	],
	"./ion-split-pane.entry.js": [
		164,
		123
	],
	"./ion-tab-bar_2.entry.js": [
		165,
		106
	],
	"./ion-tab_2.entry.js": [
		166,
		85
	],
	"./ion-text.entry.js": [
		167,
		107
	],
	"./ion-textarea.entry.js": [
		168,
		108
	],
	"./ion-toast.entry.js": [
		169,
		109
	],
	"./ion-toggle.entry.js": [
		170,
		80
	],
	"./ion-virtual-scroll.entry.js": [
		171,
		124
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 83;
module.exports = webpackAsyncContext;